import React from "react";
import { useDispatch } from "react-redux";
import type { ThunkDispatch } from "redux-thunk";

import { useDisableBodyScroll } from "../../hooks/useDisableBodyScroll";
import { pad5 } from "../../libs";
import { accountUsersActions } from "../../reducers/accountUsers";
import { WarningIcon } from "../SVGIcons";

interface UserDeleteModalProps {
  accountId: number;
  userId: number;
  employeeId: number;
  fullName: string;
  onClose: () => void;
}

const UserDeleteModal: React.FC<UserDeleteModalProps> = ({
  accountId,
  userId,
  employeeId,
  fullName,
  onClose,
}) => {
  const dispatch = useDispatch<ThunkDispatch<unknown, unknown, unknown>>();

  // モーダル表示時に背景のスクロールを無効化
  useDisableBodyScroll();

  const handleConfirm = async () => {
    try {
      const result = await dispatch(
        accountUsersActions.deleteUser({
          account_id: accountId,
          user_id: userId,
        }),
      );

      if (accountUsersActions.deleteUser.fulfilled.match(result)) {
        // 削除成功
        onClose();
      }
    } catch (error) {
      // エラーハンドリングはReduxのreducerで行われる
      console.error("削除エラー:", error);
    }
  };
  return (
    <div className="fixed inset-0 z-100 flex items-center justify-center">
      {/* 背景オーバーレイ */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      />

      {/* モーダル本体 */}
      <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md overflow-hidden">
        {/* 本文 */}
        <div className="p-6 pb-4">
          <div className="flex items-start">
            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-100">
              <WarningIcon />
            </div>
            <div className="ml-3 text-left">
              <h3 className="text-base font-semibold leading-6 text-gray-900">
                ユーザー削除
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  <span className="font-bold">{fullName}</span>
                  <span> (No={pad5(employeeId)})</span>
                  <span> を削除してもよろしいですか？</span>
                </p>
                <p className="text-sm text-red-600 mt-2">
                  ※この操作は取り消せません
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* ボトムバー */}
        <div className="flex justify-end gap-3 px-6 py-3 border-t">
          <button
            type="button"
            onClick={onClose}
            className="px-6 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            キャンセル
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="px-6 py-2 text-white bg-red-600 rounded-md hover:bg-red-700"
          >
            削除
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserDeleteModal;
